import { openIndexedDB } from './openIndexedDB'

export async function deleteImageFromIndexedDB(id: number): Promise<void> {
  const db = await openIndexedDB()
  return new Promise((resolve, reject) => {
    const transaction = db.transaction(['images'], 'readwrite')
    const store = transaction.objectStore('images')
    const request = store.delete(id)

    request.onsuccess = () => {
      resolve()
    }

    request.onerror = (event) => {
      reject(`Erro ao remover arquivo: ${event}`)
    }
  })
}
